export const isDesktopApp = () => {
    if (typeof window === 'undefined') return false

    const isLocalDesktopHost =
        window.location.hostname === 'localhost' &&
        window.location.port === '3123'

    return (
        isLocalDesktopHost ||
        window.__IS_PLODE_DESKTOP__ === true ||
        typeof window.__TAURI_INTERNALS__ !== 'undefined' ||
        typeof window.__TAURI__ !== 'undefined'
    )
}

export const isBrowser = () => !isDesktopApp()